import React from 'react';
import featureImage from '../assets/images/bakeonator_feature_section.png'; // Adjust the path as necessary


function FeatureSection() {
    return (
        <section className="my-5" id="features">
            <div className="container">
                <h2 className="text-center mb-4">Powerful Features</h2>
                <div className="row g-4 justify-content-center">
                    <div className="col-md-8">
                        <div className="feature text-center">
                            <div className="feature-icon bg-primary text-white mb-5 mx-auto"
                                 style={{width: '60px', height: '60px'}}>
                                <img src={featureImage} alt="Feature"
                                     width="auto" // Set the width as desired
                                     height="100" // Set the height as desired
                                />
                            </div>
                            <div className="mb-5"></div>
                            <h3 className="feature-title">Unlock the Power of Effortless Lightmap Baking with
                                Bakeonator</h3>
                            <p>Elevate your Unity projects with Bakeonator, the ultimate SaaS platform for seamless,
                                automated lightmap baking. Experience the pinnacle of efficiency with our fast,
                                cloud-based rendering, ensuring high-quality results that bring your game environments
                                to life. With easy integration into your existing Unity workflow, enhanced collaboration
                                features, and top-tier security, Bakeonator is designed to streamline your development
                                process, allowing you to focus on what you do best: creating stunning, immersive games.
                                Dive into a world where speed meets quality, and innovation is just a click away with
                                Bakeonator.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )

}

export default FeatureSection;